// extracted by mini-css-extract-plugin
export default {"pointer":"cursor-module__pointer__aA8Wa","notAllowed":"cursor-module__notAllowed__id7Bt"};